module.exports = ".alert-alert-danger {\n  margin-right: 1rem; }\n"